import { Colors, Typography, Shadows, Spacing } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Button from 'builder/components/Button'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 32px;
  border-radius: 8px;
  background-color: white;
  box-shadow: ${Shadows.lightWithBorderShadowMid};
  max-width: 704px;
  width: 100%;

  ${Media.Tablet`
    margin-bottom: 50px;
    max-width: unset;
  `};
`

export const Title = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.sizes.Subhead};
  font-weight: ${Typography.weights.medium};
`

export const Benefits = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 13px;
  flex-wrap: wrap;
`

export const Benefit = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 34%;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral5};
  background-color: ${Colors.Neutral5};
  padding: ${Spacing.S};

  &.blue {
    border: 1px solid ${Colors.Blue20};
    background-color: ${Colors.Blue10};
  }
`

export const Icon = styled.img`
  width: 34px;
  height: 34px;
  color: ${Colors.Neutral90};
`

export const BenefitText = styled.span<{ $isHistoricalLeads?: boolean }>`
  color: ${props => (props.$isHistoricalLeads ? Colors.Neutral50 : Colors.Neutral90)};
  ${Typography.sizes.Caption};

  &.medium {
    color: ${Colors.Neutral90};
    font-weight: ${Typography.weights.medium};
  }
`

export const ContinueButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
  font-size: 19px;
  font-weight: ${Typography.weights.medium};
  line-height: 24px;
`

export const CancelAnytime = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.sizes.Caption};
  font-weight: ${Typography.weights.medium};
  margin-top: 8px;

  &.blue {
    color: ${Colors.Blue50};
  }
`
